import { render } from "./WrapHeader.vue?vue&type=template&id=f87c256a&scoped=true"
import script from "./WrapHeader.vue?vue&type=script&lang=js"
export * from "./WrapHeader.vue?vue&type=script&lang=js"

import "./WrapHeader.vue?vue&type=style&index=0&id=f87c256a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f87c256a"]])

export default __exports__